import React from "react";

import { LiaArrowRightSolid } from "react-icons/lia";
import CardReview from "./Cards/CardReview";

export default function Review() {
  return (
    <div className="min-[1920px]:my-44 space-y-12  xl:space-y-0 mt-24 w-5/6 lg:w-full  mx-auto lg:mt-32 xl:flex xl:justify-center">
      <div className="space-y-8 lg:ml-32">
        <h1
          className="text-lg sm:text-4xl lg:text-5xl font-bold"
          id="testimonies"
        >
          Kata Orang Tentang Kami
        </h1>
        <p>Lihat ulasan yang diberikan orang lain untuk kami di google kami</p>
        <p className=" flex items-center  text-blue-500 cursor-pointer hover:text-blue-300 font-medium">
          Lihat Semua Ulasan <LiaArrowRightSolid className="ml-7" />
        </p>
      </div>

      <CardReview />
    </div>
  );
}
